import { ButtonWithTooltip } from "@/core/components/button-with-tooltip";

interface LockPeriodButtonProps {
  onClick: () => void;
  disabled: boolean;
  disabledTooltip?: string;
}

export const LockPeriodButton = ({
  onClick,
  disabled,
  disabledTooltip,
}: LockPeriodButtonProps) => (
  <ButtonWithTooltip
    size="sm"
    onClick={onClick}
    disabled={disabled}
    disabledTooltip={disabledTooltip}
  >
    Mark as paid
  </ButtonWithTooltip>
);
